import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";

import { startSpinner, finishSpinner } from "../ui/spinner";
const ConfiguracionPorTipoAfiliacionTraerStart = () => ({
  type: types.tipoDocumentacionPorTipoAfilacionTraerStart,
});
export const ConfiguracionPorTipoAfiliacionTraerError = (error) => ({
  type: types.tipoDocumentacionPorTipoAfilacionTraerError,
  payload: error,
});
export const ConfiguracionPorTipoAfiliacionTraerSuccess = (payload) => {
  return {
    type: types.tipoDocumentacionPorTipoAfilacion,
    payload: payload,
  };
};
export const configuracionLimpiar = () => ({ type: types.configuracionLimpiar });

export const traerConfiguracionPorTipoAfiliacion = (id) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(ConfiguracionPorTipoAfiliacionTraerStart());
    const response = await fetchConToken(
      `TipoDocumentacionesPorTipoAfiliacion/traerTiposDocumentacionesPorTipoAfiliacionXIdTipoAfiliacion/${id}`
    );
    if (!response.ok) {
      dispatch(ConfiguracionPorTipoAfiliacionTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      if (respuesta.length > 0) {
        dispatch(ConfiguracionPorTipoAfiliacionTraerSuccess(respuesta));
      }
    }
    dispatch(finishSpinner());
  };
};

export const modificarEstadoObligatorioTipoDocumento = (marcado,id, body) => async (
  dispatch
) => {
  const response = await fetchConToken(
    `TipoDocumentacionesPorTipoAfiliacion/${id}`,
    body,
    "PUT"
  );
  if (!response.ok) {
    throw Error(response.statusText);
  }
  dispatch({
    type: types.tipoDocumentacionPorTipoAfilacionObligatorioModificado,
    payload: { id: id, obligatorio: body.obligatorio,marcado:marcado },
  });
  //TODO dispatch de tipodocumentaciontipoafiliacion para actualizar estado docu en afiliacion
};

export const deleteEstadoMarcadoTipoDocumento = (id) => async (dispatch) => {
  const response = await fetchConToken(
    `TipoDocumentacionesPorTipoAfiliacion/${id}`,
    '',
    "DELETE"
  );
  if (!response.ok) {
    //TODO Dispatch de error y actualizacion reducer de error
    throw Error(response.statusText);
  }
        dispatch({
        type: types.tipoDocumentacionPorTipoAfilacionEliminar,
        payload: id
      });
}

export const nuevoEstadoMarcadoTipoDocumento = (id, data) => async (dispatch) => {
  const response = await fetchConToken(
    `TipoDocumentacionesPorTipoAfiliacion`,
    data,
    "POST"
  );
  if (!response.ok) {
    //TODO Dispatch de error y actualizacion reducer de error
    throw Error(response.statusText);
  }
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const res = await response.json();
      dispatch({
        type: types.tipoDocumentacionPorTipoAfilacionNuevo,
        payload: res,
      });
  } else {
      //TODO Dispatch de error y actualizacion reducer de error
    throw new Error(response);
  }
}

export const traerConfiguracionPorTipoParentesco = (IdParentesco) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(ConfiguracionPorTipoAfiliacionTraerStart());
    const response = await fetchConToken(
      `TipoDocumentacionesPorParentesco/${IdParentesco}`
    );
    if (!response.ok) {
      dispatch(ConfiguracionPorTipoAfiliacionTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      if (respuesta.length > 0) {
        dispatch(ConfiguracionPorTipoAfiliacionTraerSuccess(respuesta));
      }
    }
    dispatch(finishSpinner());
  };
};

export const modificarEstadoObligatorioTipoDocumentoParentesco = (marcado, id, body) => async (
  dispatch
) => {
  const response = await fetchConToken(
    `TipoDocumentacionesPorParentesco/${id}`,
    body,
    "PUT"
  );
  if (!response.ok) {
    throw Error(response.statusText);
  }
  dispatch({
    type: types.tipoDocumentacionPorTipoParentescoObligatorioModificado,
    payload: { id: id, obligatorio: body.obligatorio,marcado:marcado },
  });
  //TODO dispatch de tipodocumentaciontipoafiliacion para actualizar estado docu en afiliacion
};

export const nuevoEstadoMarcadoTipoDocumentoParentesco = (id, data) => async (dispatch) => {
  const response = await fetchConToken(
    `TipoDocumentacionesPorParentesco`,
    data,
    "POST"
  );
  if (!response.ok) {
    //TODO Dispatch de error y actualizacion reducer de error
    throw Error(response.statusText);
  }
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const res = await response.json();
      dispatch({
        type: types.tipoDocumentacionPorTipoParentescoNuevo,
        payload: res,
      });
  } else {
      //TODO Dispatch de error y actualizacion reducer de error
    throw new Error(response);
  }
}

export const deleteEstadoMarcadoTipoDocumentoParentesco = (id) => async (dispatch) => {
  const response = await fetchConToken(
    `TipoDocumentacionesPorParentesco/${id}`,
    '',
    "DELETE"
  );
  if (!response.ok) {
    //TODO Dispatch de error y actualizacion reducer de error
    throw Error(response.statusText);
  }
        dispatch({
        type: types.tipoDocumentacionTipoParentescoEliminar,
        payload: id
      });
}